import React from 'react'
import * as _ from 'recompose'
import { connect } from 'react-redux'
import { setPaymentData, removeUserPayment } from '../../../store/reducers/paymentMethods'
import { FormattedMessage, injectIntl } from 'react-intl'
import { compose, lifecycle, branch } from 'recompose'

// const formatExpiry = str => str.substring(4, 6) + '/' + str.substring(2, 4)

const PaymentCard = ({
  data,
  empty = false,
  selected = false,
  onSelect,
  onRemove,
  IsMobile
}) => (
  <div className='PaymentCards__item'>
    <div className={`PaymentCard ${selected && 'PaymentCard_selected'} ${empty && 'PaymentCard_empty'}`} onClick={onSelect}>
      {(!empty && data) && (
        <div className='PaymentCard__header'>
          <span className='PaymentCard__expiry'>{data.date}</span>
          <span className='PaymentCard__remove' onClick={onRemove}><FormattedMessage id='bidPayment.remove' /></span>
        </div>
      )}
      {(!empty && data) && <div className='PaymentCard__number'>•••• •••• •••• {data.card}</div>}
      {empty && <div className='PaymentCard__number'><FormattedMessage id='bidPayment.add' /></div>}
    </div>
  </div>
)

const mapState = (state, { currentMethod, paymentId }) => {
  
  const data = state.paymentMethods.data

  return ({
    ...data,
    data: state.paymentMethods.cards[paymentId] || null,
    selected: (!paymentId && !data.userPaymentId && data.paymentMethod === currentMethod) || data.userPaymentId === paymentId
  })
}

const mapDispatch = (dispatch, { paymentId = null, onChange, intl }) => ({
  onSelect: () => {
	// необходимо при выборе привязки карты, так как paymentId становится undefined, а должен быть null
	if (paymentId === 'undefined'){
      paymentId = null;
	}
    dispatch(setPaymentData('userPaymentId', paymentId))
    onChange('userPaymentId', paymentId)
  },
  onRemove: e => {
    if (window.confirm(intl.formatMessage({id: 'bidPayment.confirm_delete_card'}))) {
      e.preventDefault()
      e.stopPropagation()
      dispatch(removeUserPayment(paymentId))	  
	  // после удаления необходимо перезаписать userPaymentId со значением null, что бы выбралась привязка карты
	  dispatch(setPaymentData('userPaymentId', null))
	  onChange('userPaymentId', null)
    }
  }
})

export default injectIntl(compose(
  connect(mapState, mapDispatch),
  branch(props => !props.empty && !props.data, _.renderNothing),
  lifecycle({
    componentDidMount () {
      if (this.props.paymentId != null) {
        this.props.onSelect()
      }
    }
  })
)(PaymentCard))



// WEBPACK FOOTER //
// ./src/components/Lot/PaymentSelect/Card.js